import { i18n } from '@/lang/i18n';
import { environmentService, bookingService, postRequestHandler } from "@/utils/services";
import { format } from 'date-fns';
import { get } from 'lodash';

const DefaultState = ()=>{
  return {
    justCreated: false,
    startDate: null,
    endDate: null,
    showBookingDetails:false,
    newBooking:false,
    apiUrl : null,
    bookingsSearch:{
      startDate:null,
      endDate:null,
      includeCancelledBookings:false,
      pagination: {
        page: 1,
        per_page: 12
      },
      sort: {
        field: 'id',
        order: 'desc'
      }
    },
    isStartedBookingSearch:false,
    isBookingLoading:false,
    bookingsData:{
      bookings:[],
      pagination:null
    },
    bookingsDataforExcel:{
      bookings:[]
    },
    selectedBooking:null,
    searchCounter:-2,
    guest:null,
    bookingTotals:{},
    hotelImages:[],
    ammenitiesforhotelselected:[]
  };
},

state = DefaultState(),

getters = {
  getJustCreated: state => state.justCreated,
  getStartDate: state => state.startDate,
  getEndDate: state => state.endDate,
  bookingsSearch: state => state.bookingsSearch,
  bookings: state => state.bookings,
  loading: state => state.isBookingLoading,
  isStartedBookingSearch: state => state.isStartedBookingSearch,
  bookingsData: state => state.bookingsData,
  bookingsDataforExcel: state => state.bookingsDataforExcel,
  selectedBookingOnGrid: state => state.selectedBooking,
  guestEdit: state=> state.guest,
  searchCounter: state => state.searchCounter,
  showBookingDetails: state => state.showBookingDetails,
  bookingTotals: state => state.bookingTotals,
  newBooking: state => state.newBooking,
  hotelImages: state => state.hotelImages,
  ammenitiesforhotelselected: state=> state.ammenitiesforhotelselected
},

mutations = {
  setJustCreated(state, payload){
    state.justCreated = payload;
  },
  setStartDate(state, date) {
    state.startDate = date;
  },
  setEndDate(state, date) {
    state.endDate = date;
  },
  toggleBookingLoading(state, payload){
    state.isBookingLoading = payload;
  },

  toggleStartedBookingSearch(state, payload){
    state.isStartedBookingSearch = payload;
  },

  setBookingsSearch(state, payload){
    state.bookingsSearch = payload;
  },

  setBookingsData(state, payload){
    state.bookingsData.bookings = payload.bookings;
    if (payload.pagination){
      state.bookingsData.pagination = payload.pagination;
    }
    state.searchCounter+=1;
  },

  setBookingsDataforExcel(state, payload){
    state.bookingsDataforExcel.bookings = payload.bookings;
    if (payload.pagination){
      state.bookingsDataforExcel.pagination = payload.pagination;
    }
    state.searchCounter+=1;
  },

  setBookingTotals(state, payload) {
    state.bookingTotals = payload
  },

  setSelectedBooking(state, payload){
    state.selectedBooking = payload;
  },

  SetguestEdit(state, payload){
    state.guest = payload;
  },

  setBookingUrls(state){
    state.apiUrl = environmentService.apiUrlBooking;
    state.apiUrlHotel = environmentService.apiUrlHotel;
  },

  setSortAndOrder(state, payload){
    state.bookingsSearch.sort.field=payload.field;
    state.bookingsSearch.sort.order=payload.order;
  },

  setSearchDates(state, payload){
    if (payload.startDate && payload.endDate){
      state.bookingsSearch.startDate = format(new Date(payload.startDate), 'yyyy-MM-dd');
      state.bookingsSearch.endDate = format(new Date(payload.endDate), 'yyyy-MM-dd');
    }else{
      state.bookingsSearch.startDate = format(new Date(),'yyyy-MM-dd');
      state.bookingsSearch.endDate = format(new Date(),'yyyy-MM-dd');
    }
  },
  setSearchByCheckin(state, searchByCheckin){
    if (searchByCheckin){
      state.bookingsSearch.searchByCheckin = true
    }else{
      state.bookingsSearch.searchByCheckin = false
    }
  },
  setSearchByFuture(state, searchByFuture){
    if (searchByFuture){
      state.bookingsSearch.searchByFuture = true
    }else{
      state.bookingsSearch.searchByFuture = false
    }
  },
  setWithoutConfirmation(state, withoutConfirmation){
    if (withoutConfirmation){
      state.bookingsSearch.withoutConfirmation = true
    }else{
      state.bookingsSearch.withoutConfirmation = false
    }
  },
  updateGuestsData(state, payload) {
    state.bookingsData.bookings[payload.bookingIndex].guests = payload.guests;
  },
  updateObservationData(state, payload) {
    state.bookingsData.bookings[payload.bookingIndex].observation = payload.observation;
  },
  updateHotelBookingId(state, payload) {
    state.bookingsData.bookings[payload.bookingIndex].hotel_booking_id = payload.hotel_booking_id;
  },
  updateIntegrationBookingId(state, payload) {
    state.bookingsData.bookings[payload.bookingIndex].integration_booking_id = payload.integration_booking_id;
  }
  ,
  setSearchValues(state, payload){
    if (payload.hotelIds){
      state.bookingsSearch.hotelIds = payload.hotelIds;
    }else{
      delete state.bookingsSearch.hotelIds;
    }

    if (payload.searchField){
      state.bookingsSearch.searchField=payload.searchField;
    } else {
      delete state.bookingsSearch.searchField;
    }

    if (payload.clientIds){
      state.bookingsSearch.clientIds=[];
      state.bookingsSearch.clientIds.push(payload.clientIds);
    } else {
      delete state.bookingsSearch.clientIds;
    }

    state.bookingsSearch.includeCancelledBookings = payload.includeCancelledBookings;
  },

  setPagination(state, payload){
    state.bookingsSearch.pagination.page = payload;
  },

  setShowBookingDetails(state, payload) {
    state.showBookingDetails = payload
  },

  setNewBooking(state, payload) {
    state.newBooking = payload;
  },

  setHotelImages(state, payload) {
    state.hotelImages = payload.map(image => {
      return {
        url: image.url,
        is_primary: image.is_primary
      }
    });
  },

  setAmmenitiesforHotelid(state, payload){
    state.ammenitiesforhotelselected = payload
  },

  clearHotelImages(state) {
    state.hotelImages = [];
  },
  RESET_STATE(state){
    Object.assign(state, DefaultState());
  },

  setPagesAmountOnPagination(state, payload){
    state.bookingsSearch.pagination.per_page = payload;
  }

},

actions = {
  updateJustCreated({ commit }, payload) {
    commit('setJustCreated', payload);
  },
  updateStartDate({ commit }, date) {
    commit('setStartDate', date);
  },
  updateEndDate({ commit }, date) {
    commit('setEndDate', date);
  },
  getBookings({ commit, state }, payload) {
    commit('toggleStartedBookingSearch', true);
    commit('setWithoutConfirmation', payload.searchValues.withoutConfirmation);
    commit('setSearchByCheckin', payload.searchValues.searchByCheckin);
    commit('setSearchByFuture', payload.searchValues.searchByFuture);
    if(payload.itemsPerPage){
      commit('setPagesAmountOnPagination', payload.itemsPerPage);
    }
    else{
      commit('setPagesAmountOnPagination', DefaultState().bookingsSearch.pagination.per_page);
    }
    if (state.newBooking) {
      commit('setSearchDates',{startDate: new Date(), endDate:new Date()});
    } else {
      if (payload.calendar.calendarData) {
        commit('setSearchDates',{startDate:payload.calendar.calendarData.dateRange.start.date, endDate:payload.calendar.calendarData.dateRange.end.date});
      } else {
        commit('setSearchDates',{startDate:payload.calendar.dateRange.start.date, endDate:payload.calendar.dateRange.end.date});
      }
    }
    commit('setSearchValues', payload.searchValues);
  },

  async getHotelImages({commit, state, rootState}, payload) {
    commit('toggleBookingLoading', true);
    let result = await postRequestHandler(`${state.apiUrlHotel}/hotels/images`, payload, {headers: rootState.auth.headers});

    if (result.status == 200) {
      commit('setHotelImages', result.data);
    }
    commit('toggleBookingLoading', false);

  },

  async getAmmenitiesforHotelid({commit, state, rootState}, payload){
    let result = await postRequestHandler(`${state.apiUrlHotel}/ammenities/hotel`, payload, {headers: rootState.auth.headers});
    if (result.status == 200) {
      commit('setAmmenitiesforHotelid', result.data);
    }
  },

  clearHotelImages({commit, state}) {
    commit('clearHotelImages');
  },

  setNewBooking({commit}, payload) {
    commit('setNewBooking', payload)
  },

  async loadAsyncDataForTableExcel({ commit, state, rootState}){
    commit('toggleBookingLoading', true);
    commit('setBookingUrls');
    let payload = await postRequestHandler(`${state.apiUrl}/bookingsfortables`, state.bookingsSearch, {headers: rootState.auth.headers});
    if (payload.status==200){
      commit('setBookingsDataforExcel', {bookings: payload.bookings });
      commit('toggleBookingLoading', false);
    }else{
      commit('setBookingsDataforExcel', []);
      commit('toggleBookingLoading', false);
    }
  },
  async loadAsyncData({ commit, state, rootState }){
    commit('toggleBookingLoading', true);
    commit('setBookingUrls');
    let payload = await postRequestHandler(`${state.apiUrl}/bookings`, state.bookingsSearch, {headers: rootState.auth.headers});
    if (payload.status==200){
      commit('setBookingsData', {bookings: payload.bookings, pagination:payload.pagination });
      commit('toggleBookingLoading', false);

      if (state.newBooking) {
        await commit('setSelectedBooking', payload.bookings[0]);
        await commit('setShowBookingDetails', true);
      }
    }else{
      commit('setBookingsData', []);
      commit('toggleBookingLoading', false);
    }
  },
  setBookingTotals({ commit }, payload) {
    commit('setBookingTotals', payload)
  },
  sortAndOrder({ commit }, payload){
    commit('setSortAndOrder', payload);
  },

  paginate({ commit }, payload){
    commit('setPagination', payload);
  },

  setSelectedBooking({ commit }, payload){
    commit('setSelectedBooking', payload);
  },

  SetguestEdit({ commit }, payload){
    commit('SetguestEdit', payload);
  },

  async updateGuests({ commit, state, dispatch, rootState}, payload) {
    commit('toggleBookingLoading', true);
    i18n.locale = rootState.global.locale;
    const result = await postRequestHandler(`${state.apiUrl}/bookings/update/guests`, payload, { headers: rootState.auth.headers});

    if (result.status == 200) {
      const bookingIndex = state.bookingsData.bookings.findIndex(booking => booking.id == payload.bookingId)
      commit('updateGuestsData', {bookingIndex, guests: result.data.guests})
      dispatch('global/setToastNotification', {title: i18n.t('lang.store.booking.booking'), text: i18n.t('lang.store.booking.guestEditionSuccess'), type:'success'}, {root: true});
    } else {
      let errors = "";
      result.errors.forEach(element => {
        errors = errors + "<br>" + element;
      });
      dispatch('global/setToastNotification', {title: i18n.t('lang.store.booking.booking'), text:errors, type:'danger'}, {root: true});
      dispatch('loadAsyncData');
      dispatch('loadAsyncDataForTableExcel')
    }
    commit('toggleBookingLoading', false);
  },
  async updateObservation({ commit, state, dispatch, rootState}, payload) {
    commit('toggleBookingLoading', true);
    i18n.locale = rootState.global.locale;
    const result = await postRequestHandler(`${state.apiUrl}/bookings/update/observation`, payload, { headers: rootState.auth.headers });
    if (result.status == 200) {
      const bookingIndex = state.bookingsData.bookings.findIndex(booking => booking.id == payload.bookingId);
      commit('updateObservationData', {bookingIndex, observation: result.data.observation});
      dispatch('global/setToastNotification', {title: i18n.t('lang.store.booking.booking'), text:i18n.t('lang.store.booking.observationEditionSuccess'), type:'success'}, {root: true});
    } else {
      let errors = "";
      result.errors.forEach(element => {
        errors = errors + "<br>" + element;
      });
      dispatch('global/setToastNotification', {title: i18n.t('lang.store.booking.booking'), text:errors, type:'danger'}, {root: true});
      dispatch('loadAsyncData');
    }
    commit('toggleBookingLoading', false);
  },
  async updateHotelBookingId({ commit, state, dispatch, rootState}, payload) {
    i18n.locale = rootState.global.locale;
    const result = await postRequestHandler(`${state.apiUrl}/bookings/update/hotelBookingId`, payload, { headers: rootState.auth.headers });
    if (result.status == 200) {
      const bookingIndex = state.bookingsData.bookings.findIndex(booking => booking.id == payload.bookingId);
      commit('updateHotelBookingId', {bookingIndex, hotel_booking_id: result.data.hotel_booking_id});
      dispatch('global/setToastNotification', {title: i18n.t('lang.store.booking.booking'), text:i18n.t('lang.store.booking.HotelConfirmationEditiSuccess'), type:'success'}, {root: true});
      return true
    } else {
      let errors = "";
      result.errors.forEach(element => {
        errors = errors + "<br>" + element;
      });
      dispatch('global/setToastNotification', {title: i18n.t('lang.store.booking.booking'), text:errors, type:'danger'}, {root: true});
    }
  },
  async updateIntegrationBookingId({ commit, state, dispatch, rootState}, payload) {
    i18n.locale = rootState.global.locale;
    const result = await postRequestHandler(`${state.apiUrl}/bookings/update/integrationBookingId`, payload, { headers: rootState.auth.headers });
    if (result.status == 200) {
      const bookingIndex = state.bookingsData.bookings.findIndex(booking => booking.id == payload.bookingId);
      commit('updateIntegrationBookingId', {bookingIndex, integration_booking_id: result.data.integration_booking_id});
      dispatch('global/setToastNotification', {title: i18n.t('lang.store.booking.booking'), text:i18n.t('lang.store.booking.integrationBookingIdEditiSuccess'), type:'success'}, {root: true});
      return true
    } else {
      let errors = "";
      result.errors.forEach(element => {
        errors = errors + "<br>" + element;
      });
      dispatch('global/setToastNotification', {title: i18n.t('lang.store.booking.booking'), text:errors, type:'danger'}, {root: true});
    }
  },

  async cancelBooking({ commit, dispatch, rootState}, payload){
    commit('toggleBookingLoading', true);
    i18n.locale = rootState.global.locale;
    const result = await postRequestHandler(`${state.apiUrl}/bookings/cancel`, { bookingId: payload }, {headers: rootState.auth.headers});
    if (result.status == 200) {
      dispatch('global/setToastNotification', {title: i18n.t('lang.store.booking.booking'), text: i18n.t('lang.store.booking.cancelSuccess'), type:'success'}, { root: true});
      dispatch('loadAsyncData');
      dispatch('loadAsyncDataForTableExcel');
    } else {
      let errors = "";
      result.errors.forEach(element => {
        errors = errors + element;
      });
      dispatch('global/setToastNotification', {title: i18n.t('lang.store.booking.booking'), text: errors, type:'danger'}, { root: true});
      dispatch('loadAsyncData');
      dispatch('loadAsyncDataForTableExcel');
    }
    commit('toggleBookingLoading', false);
  },
  setBookingUrls({ commit }){
    commit('setBookingUrls');
  },

  setShowBookingDetails({ commit }, payload) {
    commit('setShowBookingDetails', payload)
  },

  async getWithoutConfirmationBookingsAmount({ commit, state, dispatch, rootState}, payload) {
    const result = await postRequestHandler(`${state.apiUrl}/bookings/countWithoutConfirmation/`, payload, { headers: rootState.auth.headers});
    if (result.status == 200) {
      return result.bookings;
    } else {
      return 0;
    }
  },

  // WARNING THIS ACTION RESETS THE STATE WITH IT'S ORIGINAL DATA
  RESET_STATE({ commit }){
    commit('RESET_STATE');
  }
};

export default {
  namespaced:true,
  state,getters,mutations,actions
};



// WEBPACK FOOTER //
// ./src/store/modules/bookings.js